import { request } from './client.ts';
import type { Reactions, ShareTarget } from '../domain.ts';

/**
 * 노트 공유와 반응 — 화면 C4 · F1-1.
 *
 * 경로가 `/notes` 아래인 것은 **노트에 딸린 것**이기 때문입니다. 공유는 그
 * 노트를 누가 볼 수 있는가이고, 반응은 그 노트에 달린 것입니다.
 *
 * 반응을 바꾸는 요청은 전부 **바뀐 전체를 되돌려 줍니다.** 이모티콘 하나를
 * 눌렀을 때 화면이 스스로 개수를 세면, 같은 순간 남이 누른 것과 어긋납니다.
 */

/* ── 공유 ─────────────────────────────────────────────────────── */

/** 고를 수 있는 친구와 지금 가 있는지. 차단한 상대는 빠져서 옵니다 */
export async function shareTargets(noteId: string): Promise<ShareTarget[]> {
  const res = await request<{ targets: ShareTarget[] }>(`/notes/${noteId}/share`);
  return res.targets;
}

/**
 * 공유 대상을 **통째로 맞춥니다** — 켠 것만 남고 끈 것은 떨어집니다.
 *
 * 더하기와 빼기를 따로 보내지 않는 것은 화면이 체크 목록이기 때문입니다.
 * 사용자가 보고 누른 그 모습이 결과가 되는 편이 덜 놀랍습니다.
 */
export async function setShareTargets(
  noteId: string,
  userIds: string[],
): Promise<ShareTarget[]> {
  const res = await request<{ targets: ShareTarget[] }>(`/notes/${noteId}/share`, {
    method: 'PUT',
    body: { userIds },
  });
  return res.targets;
}

/* ── 반응 ─────────────────────────────────────────────────────── */

export async function loadReactions(noteId: string): Promise<Reactions> {
  const res = await request<{ reactions: Reactions }>(`/notes/${noteId}/reactions`);
  return res.reactions;
}

/** 같은 것을 다시 누르면 뗍니다 — 서버가 켜고 끄는 것을 정합니다 */
export async function toggleEmoji(noteId: string, emoji: string): Promise<Reactions> {
  const res = await request<{ reactions: Reactions }>(`/notes/${noteId}/reactions/emoji`, {
    method: 'PUT',
    body: { emoji },
  });
  return res.reactions;
}

export async function addComment(noteId: string, body: string): Promise<Reactions> {
  const res = await request<{ reactions: Reactions }>(`/notes/${noteId}/reactions/comments`, {
    method: 'POST',
    body: { body },
  });
  return res.reactions;
}

export async function removeComment(reactionId: string): Promise<Reactions> {
  const res = await request<{ reactions: Reactions }>(`/reactions/${reactionId}`, {
    method: 'DELETE',
  });
  return res.reactions;
}
